import React from 'react';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import moment from 'moment';
import { HOIDONGDAODUC_API } from '../../../../utils/apiUrl';
import { Put } from '../../../../utils/httpProvider';
import DocumentInput from '../../../../components/document-input/DocumentInput';

const schema = yup.object().shape({
    soQuyetDinh: yup.string().required('Vui lòng nhập số quyết định'),
    ngayCap: yup.date().required('Vui lòng nhập ngày cấp'),
    donViCap: yup.string().required('Vui lòng nhập đơn vị cấp')
});

const HoiDongDaoDucEdit = ({ hoSoId, dataEdit, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const editFunc = useMutation((value) => Put(HOIDONGDAODUC_API.UPDATE_ITEM, dataEdit.id, value));

    const handleUpdate = (values, { setSubmitting }) => {
        const requestData = {
            id: dataEdit.id,
            hoSoNghienCuuSinhId: hoSoId,
            soQuyetDinh: values.soQuyetDinh,
            ngayCap: values.ngayCap || null,
            donViCap: values.donViCap,
            fileHDDD: values.fileHDDD,
            ghiChuChinhSua: values.ghiChuChinhSua,
            trangThai: dataEdit.trangThai ?? dataEdit.TrangThai ?? 0
        };

        editFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204)) {
                    toast.success('Cập nhật thành công');
                    queryClient.invalidateQueries(['hoiDongDaoDucData', hoSoId]);
                    queryClient.invalidateQueries(['duyetHoiDongDaoDucData', hoSoId]);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Cập nhật Hội đồng đạo đức</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleUpdate}
                    initialValues={{
                        soQuyetDinh: dataEdit.soQuyetDinh || '',
                        ngayCap: dataEdit.ngayCap ? moment(dataEdit.ngayCap).format('YYYY-MM-DD') : '',
                        donViCap: dataEdit.donViCap || '',
                        fileHDDD: dataEdit.fileHDDD || '',
                        ghiChuChinhSua: dataEdit.ghiChuChinhSua || ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Số quyết định <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="soQuyetDinh"
                                            value={values.soQuyetDinh}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.soQuyetDinh && !!errors.soQuyetDinh && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.soQuyetDinh}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Ngày cấp <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayCap"
                                            value={values.ngayCap}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.ngayCap && !!errors.ngayCap && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.ngayCap}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Đơn vị cấp <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="donViCap"
                                            value={values.donViCap}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {touched.donViCap && !!errors.donViCap && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.donViCap}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <DocumentInput
                                            labelTitle="File Hội đồng đạo đức"
                                            value={values.fileHDDD}
                                            onChangeProp={(url) => setFieldValue('fileHDDD', url)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>


                            <div className="text-right mt-3">
                                <Button
                                    variant="secondary"
                                    onClick={() => setViewMode('list')}
                                    className="mr-2"
                                >
                                    Hủy
                                </Button>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? <><i className="fas fa-spinner fa-spin mr-1"></i> Cập nhật</> : 'Cập nhật'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default HoiDongDaoDucEdit;
